import Controller from './Controller';
import type Report from '../checks/Report';
import { CEMC_Object } from '../commands/metamodel/complex';
import { Combined_DeleteObject } from '../commands/combined';
import type { OrId, ObjectUpdates, PropagateRename, IdOptionMap } from '../commands/types';
import type { IObjectType } from '../../stores/model/metamodel/object_type';

/**
 * Edit or delete an object type
 */
export default class EditObjectController extends Controller {
  async editObject(
    id: OrId<IObjectType>,
    updates: ObjectUpdates,
    propagateRename: PropagateRename | boolean | null
  ): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = CEMC_Object(model, id, updates, propagateRename);
      return checks;
    });
  }

  async deleteObject(
    id: OrId<IObjectType>,
    removeEvents = false,
    inheritanceOptions: Record<string, IdOptionMap | undefined> = {}
  ): Promise<Report> {
    return this.executeAndCheck((model) => {
      const { checks } = Combined_DeleteObject(model, id, removeEvents, inheritanceOptions);
      return checks;
    });
  }
}
